import React, { useEffect, useState, useReducer, useContext } from "react"
import Summary from "../Common/Place/Summary"
import Sort from "./ResultSet/Sort"
import Icon from "../Utils/Icon"
import Loader from "../Common/Loader"
import Feedback from "../Common/Feedback"
import { PlaceSearcher } from "../Utils/place_searcher"

import * as styles from "./Styles/ResultSet.module.scss"
import "../../styles/layouts"
import classNames from "classnames/bind"
import { PCViewContext } from "../Common/PCViewContext"
const cn = classNames.bind(styles)

const execFetch = async (props, page, handleLoad) => {
  const searcher = new PlaceSearcher(props.searchPath, {
    category: props.category,
    city: props.city,
    prefecture: props.prefecture,
    onLoad: handleLoad,
    page: page,
    from: window.location.search.match("current_location")
      ? "current_location"
      : null,
  })
  searcher.search()
}

const pageReducer = (page, action) => {
  if (page < action.page) {
    return action.page
  }
  return page
}

const FeedbackRow = () => {
  return (
    <React.Fragment>
      <div style={{ margin: "1rem" }}>
        <Feedback />
      </div>
      <hr className="common-hr" style={{ margin: "1rem 1rem 0" }} />
    </React.Fragment>
  )
}

const ResultSet = (props) => {
  const isPC = useContext(PCViewContext)
  const deviceFlag = isPC ? "pc" : "sp"
  const [results, setResults] = useState([])
  const [paging, setPaging] = useState({
    count: null,
    next: 0,
    page: 1,
    last: null,
  })
  const [page, dispatchPage] = useReducer(pageReducer, 1)
  const [loading, setLoading] = useState(false)

  const handleLoad = (res, code) => {
    setLoading(false)
    if (code != 200 || !res.results) {
      return alert("通信に失敗しました。時間を置いてもう一度お試しください。")
    }
    setPaging(res.paging)
    if (
      results.length < res.paging.items + res.paging.offset &&
      page == res.paging.page
    ) {
      const places = JSON.parse(res.results)
      setResults(results.concat(places))
    }
  }
  useEffect(() => {
    let mounted = true
    if (!props.searchPath) {
      return
    }
    const code = async () => {
      if (mounted) {
        setLoading(true)
        await execFetch(props, page, handleLoad)
      }
    }
    code()
    return () => {
      mounted = false
    }
  }, [page])

  return (
    <div className={cn("container", deviceFlag)}>
      <div className={cn("l-flex", "l-flex-space-between", "row", deviceFlag)}>
        <div>
          {paging.count != null && (
            <React.Fragment>
              <span className={styles.resultNum}>{paging.count}</span>
              <span className={styles.resultNote}>件の施設</span>
            </React.Fragment>
          )}
        </div>
        {/* <Sort {...props} /> */}
      </div>
      <hr className="common-hr" />
      {results.length > 0 &&
        results.map((place, i) => (
          <React.Fragment key={i}>
            <div
              className={cn(
                "resultContainer",
                i == results.length - 1 ? "js-last-item" : ""
              )}
            >
              <div className={styles.innerRow}>
                <Summary place={place} {...props} />
              </div>
              {i != results.length - 1 && <hr className="common-hr" />}
              {i == results.length && paging.next != null && (
                <hr className="common-hr" />
              )}
            </div>
            {results.length >= 10 && i === 10 && <FeedbackRow />}
            {results.length < 10 && i === results.length - 1 && <FeedbackRow />}
          </React.Fragment>
        ))}
      {!loading && results.length == 0 && (
        <div
          className="l-centering l-flex--column"
          style={{ padding: "50px 0" }}
        >
          <div>
            <Icon className={styles.noResult} type="original" name="domain" />
          </div>
          <div className={styles.notFound}>
            条件に合うお店・施設が
            <br />
            見つかりませんでした
          </div>
        </div>
      )}
      {paging.next != null && !loading && (
        <div>
          <a
            href="#"
            className={cn(styles.more, deviceFlag)}
            onClick={(e) => {
              e.preventDefault()
              dispatchPage({ page: page + 1 })
            }}
          >
            <div>
              <Icon
                className={styles.more}
                type="feather"
                name="chevron-down"
              />
              <span>もっと見る</span>
            </div>
          </a>
        </div>
      )}
      <Loader show={loading} color="green" small={false} />
    </div>
  )
}

export default ResultSet
